import {softwarePath} from "../../../shared/software-copy";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  setLocaleInPath,
  changeLocale,
  SUPPORTED_LOCALES,
  SUPPORTED_LOCALES_ARRAY,
  type SupportedLocale,
} from "@/i18n";
import { cn } from "@/lib/utils";
import { Check, Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";

export default function LocaleSwitcher() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const currentMeta = SUPPORTED_LOCALES[i18n.language as keyof typeof SUPPORTED_LOCALES];

  const handleChangeLocale = (newLng: SupportedLocale) => {
    if(/^\/crm\/api\/(?:pcdiag|software\/[a-z0-9-]+)\/verifica$/.test(location.pathname)){
      void changeLocale(newLng);
      navigate(location.pathname+'?lingua='+newLng,{replace:true});
      return;
    }
    // Navigate to new locale URL - LocaleWrapper will update state
    const match=/^\/(it|en|es|fr|de)\/(software|logiciels)(?:\/([a-z0-9-]+))?\/?$/.exec(location.pathname);
    const newPath = match?softwarePath(newLng,match[3])+location.search+location.hash:setLocaleInPath(newLng, location.pathname, location.search, location.hash);
    navigate(newPath);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2" aria-label={`${currentMeta?.code.toUpperCase() ?? i18n.language.toUpperCase()} — ${t("a11y.change_language", { ns: "common" })}`}>
          <Globe aria-hidden="true" className="h-4 w-4" />
          <span className="hidden sm:inline">{currentMeta?.code.toUpperCase()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {SUPPORTED_LOCALES_ARRAY.map((lng) => {
          const meta = SUPPORTED_LOCALES[lng];
          const isActive = i18n.language === lng;
          return (
            <DropdownMenuItem
              key={lng}
              onClick={() => handleChangeLocale(lng)}
              className="cursor-pointer"
            >
              <Check className={cn("mr-2 h-4 w-4", isActive ? "opacity-100" : "opacity-0")} />
              <span className="mr-2">{meta.emoji}</span>
              <span className="flex-1">{meta.nativeName}</span>
              <span className="text-muted-foreground ml-2 text-xs">{meta.name}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
